import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from "angular-animations";

// https://github.com/filipows/angular-animations#readme
export const Fade = [
  fadeInOnEnterAnimation({
    delay: 0,
    duration: 1000,
    anchor: "enter",
  }),
  fadeOutOnLeaveAnimation({
    delay: 300,
    duration: 500,
    anchor: "leave",
  }),
];
